import styled from "styled-components";
import BackButton from "@/components/BackButton";


export const ButtonContainer = styled(BackButton)``;
